/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    CriticalNotificationDto,
    CriticalNotificationDtoFromJSON,
    CriticalNotificationDtoToJSON,
} from '../models';

/**
 * 
 */
export class CriticalNotificationsApi extends runtime.BaseAPI {

    /**
     * Get list of active critical notifications
     */
    async criticalNotificationControllerGetListRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<CriticalNotificationDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/critical-notifications/list`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CriticalNotificationDtoFromJSON));
    }

    /**
     * Get list of active critical notifications
     */
    async criticalNotificationControllerGetList(initOverrides?: RequestInit): Promise<Array<CriticalNotificationDto>> {
        const response = await this.criticalNotificationControllerGetListRaw(initOverrides);
        return await response.value();
    }

}
